import { Box, Link, List, ListItem } from '@mui/material';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ActivityEnum, AdminSubactivityEnum, useUserActivityTracker } from '../UserActivityTracker';
import { UserApi } from '../api/UserApi';
import { handleErrorMessage } from '../component/ErrorDialog';
import AppBarContext from '../context/AppBarContext';


export default function AdminHomePage() {

    useUserActivityTracker(ActivityEnum.Admin, AdminSubactivityEnum.HomePage)

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    React.useEffect(() => {
        UserApi.assertAdmin()
            .then(response => {
                if (response.status < 300) {
                    return response.data
                }
                console.error(response)
                handleErrorMessage(response, setErrorMessage, history, location);
                return []
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
    }, [history, location, setErrorMessage])

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2
            }}
        >
            <List sx={{ gap: 2 }}>
                <ListItem><h3>Course & Content</h3></ListItem>
                <ListItem>
                    <Link href="/course_offering" underline="hover">
                        Course Offering (Students for class)
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/dialog_plan" underline="hover">
                        Create and Edit Lesson Templates
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/create_lesson" underline="hover">
                        Create and Edit Lessons
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/regen_audio" underline="hover">
                        Regenerate Audio & Queue
                    </Link>
                </ListItem>
                <ListItem><h3>Users</h3></ListItem>
                <ListItem>
                    <Link href="/user_admin" underline="hover">
                        User Admin
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/report/user_dialog_prompt" underline="hover">
                        Student Lesson Completion Report
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/report/sentence_score" underline="hover">
                        Student Audio Report
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/manual_grade_audio" underline="hover">
                        Manually Grade Audio
                    </Link>
                </ListItem>
                <ListItem>
                    <Link href="/report/comment" underline="hover">
                        Comment Report
                    </Link>
                </ListItem>
            </List>
        </Box>
    );
}
